import React, { Component } from "react";
import { Switch } from "antd";

import "./index.less";

export default class DataSwitch extends Component {

  state = {
    loading: true,
    checkedCode: {},
    unCheckedCode: {}
  };

  componentDidMount() {
    this.load();
  };

  load = () => {
    this.props.onLoad().then(options => {
      let checkedCode = {}, unCheckedCode = {};
      options = this.getOptions(options);
      options.forEach(item => {
        if (this.getCheckedValue() === item.value) {
          checkedCode = item;
        }
        if (this.getUnCheckedValue() === item.value) {
          unCheckedCode = item;
        }
      });
      this.setState({
        ...this.state,
        loading: false,
        checkedCode,
        unCheckedCode,
      });
    });
  };

  getOptions = (data) => {
    let options = [...data].map(item => ({
      label: item.label,
      value: item.value,
    }));
    return options;
  };

  getValue = (checked) => {
    if (typeof checked !== "undefined") {
      return checked ? this.getCheckedValue() : this.getUnCheckedValue();
    }
    return this.props.value;
  };

  getChecked = () => {
    const { value, } = this.props;
    return value === this.state.checkedCode.value;
  };

  getCheckedValue = () => {
    return this.props.checkedValue;
  };

  getUnCheckedValue = () => {
    return this.props.unCheckedValue;
  };

  getCheckedChildren = () => {
    return this.state.checkedCode.label || "";
  };

  getUnCheckedChildren = () => {
    return this.state.unCheckedCode.label || "";
  };

  onClick = (checked) => {
    const value = this.getValue(checked);
    this.props.onClick && this.props.onClick(value)
  };

  onChange = (checked) => {
    const value = this.getValue(checked);
    this.props.onChange && this.props.onChange(value)
  };

  render() {
    return (
      <Switch
        {...this.props}
        onClick={this.onClick}
        onChange={this.onChange}
        checked={this.getChecked()}
        checkedChildren={this.getCheckedChildren()}
        unCheckedChildren={this.getUnCheckedChildren()}
      />
    );
  };
};
